/* cc-pdp-v2.js — JS consolidado para PDP V2.
   Funciones:
     1. Variant change sync (picker → hidden input + low-stock + sticky)
     2. COD button intercept (add to cart + redirect a pag confirmacion)
     3. Size guide modal (open/close/ESC/backdrop)
     4. Sticky CTA mobile (IntersectionObserver)
     5. Alt text auto-fill para imagenes sin alt
     6. Quantity selector (+/-)
*/
(function(){
  'use strict';

  /* =====================================================
     Variant data — prefiere JSON embebido en el picker (sección modular,
     estilo Dawn) y cae a window.ccProductData (sección monolítica V2).
     ===================================================== */
  var _variantsCache = null;
  function getVariantsData(){
    if (_variantsCache) return _variantsCache;
    var node = document.querySelector('script[type="application/json"][data-cc-pdp-variants]');
    if (node){
      try {
        var parsed = JSON.parse(node.textContent || '[]');
        if (Array.isArray(parsed) && parsed.length){
          _variantsCache = parsed;
          return _variantsCache;
        }
      } catch (e) {
        console.warn('cc-pdp-v2: variants JSON parse failed', e);
      }
    }
    if (window.ccProductData && Array.isArray(window.ccProductData.variants)){
      _variantsCache = window.ccProductData.variants;
      return _variantsCache;
    }
    return [];
  }
  function getVariantById(id){
    var variants = getVariantsData();
    for (var i = 0; i < variants.length; i++){
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }
  function findVariantByOption1(value){
    var variants = getVariantsData();
    for (var i = 0; i < variants.length; i++){
      if (variants[i].option1 === value) return variants[i];
    }
    return null;
  }

  /* =====================================================
     Selector de talla (chips radio) + sync
     ===================================================== */
  function initSizePicker(){
    var root = document.querySelector('.cc-size-picker');
    var hiddenId = document.querySelector('.cc-pdp-form input[name="id"]');
    if (!root || !hiddenId) return;

    root.addEventListener('change', function(e){
      if (!e.target.matches('input[type="radio"]')) return;
      var value = e.target.value;
      syncSizeLabel(root, value);   // eng19 A48: la leyenda «Talla:» sigue a la talla marcada
      var variant = findVariantByOption1(value);
      if (!variant) return;
      hiddenId.value = variant.id;
      // Force mutation event for observers
      hiddenId.setAttribute('value', variant.id);
      syncLowStock(variant);
      syncPrice(variant);
      syncStickyInfo(variant);
      updateCodButtonState(variant);
    });

    // Initial sync
    var checked = root.querySelector('input[type="radio"]:checked');
    if (checked){
      syncSizeLabel(root, checked.value);
      var v = findVariantByOption1(checked.value);
      if (v){
        // FIX 2026-05-10: defensa en profundidad — sincronizar hidden id en el
        // initial sync para que coincida con la radio checked aunque el change
        // event original se haya evaporado (ver Fix 1).
        hiddenId.value = v.id;
        hiddenId.setAttribute('value', v.id);
        syncLowStock(v);
        syncPrice(v);
        syncStickyInfo(v);
        updateCodButtonState(v);
      }
    }
  }

  // eng19 (2026-10-19) A48: el servidor pinta current.option1 (primera disponible) y preSelectPopularSize marca
  // otra talla (p. ej. 7 1/4): sin esto la leyenda decia «Talla: 7» con 7 1/4 marcada (y en el carrito iba 7 1/4).
  function syncSizeLabel(root, value){
    var lbl = root.querySelector('legend strong');
    if (lbl && value) lbl.textContent = value;
  }

  function syncPrice(variant){
    var priceEl = document.querySelector('.cc-pdp-v2__price');
    if (priceEl && variant.price_formatted){
      priceEl.textContent = variant.price_formatted;
    }
  }

  function syncLowStock(variant){
    var el = document.querySelector('.cc-pdp-v2__low-stock');
    if (!el) return;
    var threshold = parseInt(el.dataset.threshold || '2', 10);
    var qty = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
    var managed = variant.inventory_management === 'shopify';

    if (managed && qty !== null && qty > 0 && qty <= threshold && variant.available){
      var txt = el.querySelector('[data-low-stock-text]');
      if (txt){
        txt.textContent = '¡Solo quedan ' + qty + ' en talla ' + variant.option1 + '!';
      }
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function updateCodButtonState(variant){
    var codBtn = document.querySelector('.cc-pdp-cta--cod');
    var cartBtn = document.querySelector('.cc-pdp-cta--cart');
    if (!variant.available){
      if (codBtn){ codBtn.disabled = true; codBtn.textContent = 'AGOTADO'; }
      if (cartBtn){ cartBtn.disabled = true; cartBtn.textContent = 'AGOTADO'; }
    } else {
      if (codBtn && codBtn.disabled){ codBtn.disabled = false; codBtn.textContent = 'PAGAR CONTRA ENTREGA'; }
      if (cartBtn && cartBtn.disabled){ cartBtn.disabled = false; cartBtn.textContent = 'AGREGAR AL CARRITO'; }
    }
  }

  /* =====================================================
     COD button: add to cart + redirect
     ===================================================== */
  function initCodButton(){
    document.querySelectorAll('.cc-pdp-cta--cod').forEach(function(btn){
      btn.addEventListener('click', async function(e){
        e.preventDefault();
        var form = btn.closest('form');
        if (!form) return;
        btn.disabled = true;
        var origText = btn.textContent;
        btn.textContent = 'AGREGANDO...';
        try {
          var fd = new FormData(form);
          var res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
          if (res.ok){
            window.location.href = '/pages/confirmar-pago-contra-entrega';
            return;
          }
          throw new Error('add failed');
        } catch(err){
          console.error('COD add error', err);
          btn.disabled = false;
          btn.textContent = origText;
        }
      });
    });
  }

  /* =====================================================
     Carrito nativo: el form es action=/cart/add, submit estandar
     funciona. Si el tema tiene cart-drawer listener, dejarlo manejar.
     ===================================================== */

  /* =====================================================
     Sticky CTA mobile
     ===================================================== */
  function initStickyCTA(){
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (!sticky) return;
    var mainForm = document.querySelector('.cc-pdp-form');
    if (!mainForm) return;

    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var visible = !entry.isIntersecting;
          sticky.setAttribute('data-visible', visible ? 'true' : 'false');
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
      io.observe(mainForm);
    }

    var codBtn = sticky.querySelector('[data-sticky-cod]');
    var cartBtn = sticky.querySelector('[data-sticky-cart]');
    if (codBtn) codBtn.addEventListener('click', function(){
      var target = document.querySelector('.cc-pdp-cta--cod');
      if (target) target.click();
    });
    if (cartBtn) cartBtn.addEventListener('click', function(){
      var target = document.querySelector('.cc-pdp-cta--cart');
      if (target) target.click();
    });
  }

  function syncStickyInfo(variant){
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (!sticky) return;
    var sizeEl = sticky.querySelector('[data-sticky-size]');
    var priceEl = sticky.querySelector('.cc-pdp-sticky__price');
    if (sizeEl && variant.option1) sizeEl.textContent = 'Talla ' + variant.option1;
    if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;
    sticky.setAttribute('data-variant-id', variant.id);
  }

  /* =====================================================
     Size guide modal
     ===================================================== */
  function initSizeGuideModal(){
    document.querySelectorAll('[data-open-size-guide]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var modal = document.querySelector('[data-size-guide-modal]');
        if (modal){
          modal.hidden = false;
          var closeBtn = modal.querySelector('[data-close-modal]');
          if (closeBtn) closeBtn.focus();
        }
      });
    });
    document.querySelectorAll('[data-close-modal]').forEach(function(el){
      el.addEventListener('click', function(){
        var modal = el.closest('[data-size-guide-modal]');
        if (modal) modal.hidden = true;
      });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){
        document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach(function(m){ m.hidden = true; });
      }
    });
  }

  /* =====================================================
     Quantity selector
     ===================================================== */
  function initQuantity(){
    document.querySelectorAll('.cc-pdp-v2__qty').forEach(function(wrap){
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.querySelectorAll('button[data-qty-step]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var step = parseInt(btn.dataset.qtyStep, 10) || 1;
          var current = parseInt(input.value, 10) || 1;
          var next = Math.max(1, current + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* =====================================================
     Alt text auto-fill
     ===================================================== */
  function fillMissingAltText(){
    var titleEl = document.querySelector('.cc-pdp-v2__title');
    var productTitle = titleEl ? titleEl.textContent.trim() : '';
    if (!productTitle) return;
    var scope = document.querySelector('.cc-main-product-v2') || document;
    var imgs = scope.querySelectorAll('img');
    var idx = 0;
    imgs.forEach(function(img){
      idx++;
      if (!img.alt || img.alt.trim() === ''){
        img.alt = productTitle + ' — vista ' + idx;
      }
    });
  }

  /* =====================================================
     Pre-selección de talla popular (Plan B 2026-05-02)
     Solo dispara si el variant picker tiene data-popular-size con valor.
     Cero impacto si el atributo está vacío o ausente (caso del monolito original).
     ===================================================== */
  function preSelectPopularSize(){
    var picker = document.querySelector('.cc-size-picker[data-popular-size]');
    if (!picker) return;
    var popular = (picker.getAttribute('data-popular-size') || '').trim();
    if (!popular) return;
    try {
      if (new URL(window.location.href).searchParams.has('variant')) return;
    } catch (e) {}
    var radios = picker.querySelectorAll('input[type="radio"]:not([disabled])');
    var target = null;
    radios.forEach(function(r){ if (target) return; if (r.value === popular) target = r; });
    if (!target && radios.length){
      radios.forEach(function(r){ if (target) return; if (!r.checked) target = r; });
    }
    if (target && !target.checked){
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* =====================================================
     Init
     ===================================================== */
  function init(){
    // FIX 2026-05-10: initSizePicker DEBE engancharse ANTES que preSelectPopularSize
    // para que el change event que preSelect dispara sea escuchado por el listener
    // que sincroniza el hidden input 'id'. Bug confirmado con orden CCS1404 y
    // test manual en producto NEW YORK YANKEES NEGRO CLASICA.
    initSizePicker();
    preSelectPopularSize();
    initCodButton();
    initStickyCTA();
    initSizeGuideModal();
    initQuantity();
    fillMissingAltText();
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
